export class ProductInventoryDto {
  source: string;
  loadType: string;
  isRealtimeInventory: boolean;
  id?: string;

  constructor(d?: ProductInventoryDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
